const h2Elements = document.querySelectorAll('.prose h2,.prose h3,.prose h4,.prose h5,.prose h6');
const highlightsContainer = document.querySelectorAll('.highlights');

h2Elements.forEach((h2, index) => {
    if (h2.innerText !== "") {
        const uniqueId = `highlight_${index}`;
        h2.id = uniqueId;

        // Loop through all highlights containers
        highlightsContainer.forEach((container) => {
            let ulTag = container.querySelector('ul');
            if (!ulTag) {
                ulTag = document.createElement('ul');
                container.appendChild(ulTag); 
            }

            // Create a new anchor tag for each container
            const aTag = document.createElement('a');
            aTag.textContent = h2.textContent;
            aTag.setAttribute('href', `#${uniqueId}`);

            // Create the li and append the aTag to it
            const liTag = document.createElement('li');
            liTag.appendChild(aTag); 
            ulTag.appendChild(liTag); // Add li to ul
        });
    }
});